import React from 'react';

import './styles.css';

function Alert({ msg, error, onClose }) {
  return (
    <div className={`wa-alert${error ? ' error' : ''}`}>
        <p>{msg}</p>
        <button type="button" onClick={onClose}>
        <i className="fas fa-regular fa-ban" />
        </button>
    </div>
  );
}

export default Alert;


// WEBPACK FOOTER //
// ./src/components/Pages/Wallet/components/ui/Alert/index.js